import React, { useEffect, useState } from "react";
import { CalendarTodayRounded } from "@mui/icons-material";
import { Box, Stack, useTheme } from "@mui/material";
import DatePicker from "react-datepicker";
import { formatToLocalDate } from "src/utils/format-to-local-date";
import moment from "moment";
import getBorderColor from "src/utils/get-border-color";

const DateTimeRangePicker = ({
  dateRange,
  onDateRangeChange,
  setFormattedDateRange,
}) => {
  const theme = useTheme();
  const userTimezone = moment.tz.guess();
  const [selectedTimezone, setSelectedTimezone] = useState(userTimezone || "");
  const convertToUserTimezone = (date) => {
    if (!date) return "";
    return formatToLocalDate(moment(date).tz(selectedTimezone).toDate());
  };

  useEffect(() => {
    const fromUTC = convertToUserTimezone(dateRange?.from);
    const toUTC = convertToUserTimezone(dateRange?.to);
    setFormattedDateRange({
      from: fromUTC,
      to: toUTC,
    });
  }, [dateRange, selectedTimezone]);
  return (
    <Stack
      // mb={1}
      mt=""
      direction="row"
      justifyContent="flex-start"
      alignItems={"center"}
      gap={1}
      sx={{
        "& .react-datepicker__input-container input": {
          fontSize: "14px",
          fontWeight: 500,
          fontFamily: "inherit",
          color: `${theme.palette.text.primary} !important`,
          border: "none",
          maxWidth: "130px",
        },
      }}
    >
      <Box
        sx={{
          px: 1,
          py: 0.8,
          border: `1px solid ${getBorderColor(theme.palette.mode)}`,
          borderRadius: 1,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 1,
          "& .react-datepicker__input-container input": {
            backgroundColor: "transparent"
          }
        }}
        className="glass-input"
      >
        <CalendarTodayRounded
          sx={{ fontSize: "20px", color: theme.palette.text.primary }}
        />

        <DatePicker
          dateFormat="MM-dd-yyyy HH:mm"
          showTimeSelect
          timeFormat="HH:mm"
          placeholderText="mm-dd-yyyy"
          selected={dateRange?.from}
          maxDate={dateRange?.to || new Date()}
          onChange={(date) => onDateRangeChange("from", date)}
          dayClassName={(date) =>
            dateRange?.from &&
            date?.toDateString() === dateRange?.from?.toDateString()
              ? "selected_day"
              : ""
          }
        ></DatePicker>
      </Box>
      <Box>
        <span>-</span>
      </Box>
      <Box
        sx={{
          px: 1,
          py: 0.8,
          border: `1px solid ${getBorderColor(theme.palette.mode)}`,
          borderRadius: 1,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 1,
          "& .react-datepicker__input-container input": {
            backgroundColor: "transparent"
          }
        }}
        className="glass-input"
      >
        <CalendarTodayRounded
          sx={{ fontSize: "20px", color: theme.palette.text.primary }}
        />

        <DatePicker
          dateFormat="MM-dd-yyyy HH:mm"
          showTimeSelect
          timeFormat="HH:mm"
          placeholderText="mm-dd-yyyy"
          selected={dateRange?.to}
          minDate={dateRange?.from}
          maxDate={new Date()}
          onChange={(date) => onDateRangeChange("to", date)}
          dayClassName={(date) =>
            dateRange?.to &&
            date?.toDateString() === dateRange?.to?.toDateString()
              ? "selected_day"
              : ""
          }
        ></DatePicker>
      </Box>
    </Stack>
  );
};

export default DateTimeRangePicker;
